
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/print",
      function () {
        return require("private-next-pages/print/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/print"])
      });
    }
  